'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validators = undefined;

var _ValidatorFactory = require('./ValidatorFactory');

// todo: deprecated - remove
var validators = exports.validators = new _ValidatorFactory.ValidatorFactory();


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/aurora-javascript-utils/dist/validators.js
// module id = 1353
// module chunks = 118